import useCXI from 'modules/cxi/useCXI';
import React from 'react';

import { theme } from 'styles/themes';
import { ProgressBarCircle } from './ProgressBarCircle';
import * as Styled from './StyledProgressBar';

export const ProgressBar = () => {
    const { t, vars } = useCXI();
    const { cxi } = vars;
    const { metrics } = cxi;

    function calcStage1() {
        let m1 = Number(metrics?.stage1.feedbacksPositive || 0) / 10;
        if (m1 > 1) m1 = 1;
        return (m1 * 100) / 1;
    }
    function calcStage2() {
        let m1 = Number(metrics?.stage2.feedbacksPositive || 0) / 10;
        if (m1 > 1) m1 = 1;
        return (m1 * 100) / 1;
    }
    function calcStage3() {
        let m1 = Number(metrics?.stage3.feedbacksPositive || 0) / 10;
        let m2 = Number(metrics?.stage3.mentoringSessions || 0) / 5;
        if (m1 > 1) m1 = 1;
        if (m2 > 1) m2 = 1;
        return (m1 * 100 + m2 * 100) / 2;
    }

    let startups = cxi.metrics.matches || 0;
    if (startups > 100) startups = 100;

    // const points = String(vars.cxi.metrics?.points || 0).padStart(2, '0');
    // const value = Number(vars.cxi.metrics?.points / 30) * 100;
    const value = Math.round(
        Number(calcStage1() * 0.3 + calcStage2() * 0.3 + calcStage3() * 0.3 + startups * 0.1)
    );

    const stroke = { path: { stroke: `url(#progress)`, height: '100%' } };
    const patchs = { path: { stroke: `url(#fullpath)`, height: '100%' } };

    return (
        <Styled.ProgressBar>
            <svg style={{ height: 0, width: 0 }}>
                <defs>
                    <linearGradient id="progress" gradientTransform="rotate(90)">
                        <stop offset="0%" stopColor={theme.colors.stage1} />
                        <stop offset="100%" stopColor={theme.colors.stage3} />
                    </linearGradient>
                    <linearGradient id="fullpath" gradientTransform="rotate(90)">
                        <stop offset="0%" stopColor="#d5d5d5" />
                        <stop offset="100%" stopColor="#d5d5d5" />
                    </linearGradient>
                </defs>
            </svg>

            <ProgressBarCircle strokeWidth={15} styles={patchs} value={100} />
            <ProgressBarCircle strokeWidth={15} styles={stroke} value={value} />

            <Styled.ProgressBarContent>
                <span className="num">{value}%</span>
                <span className="txt">{t('home.ProgressBar.program')}</span>
            </Styled.ProgressBarContent>
        </Styled.ProgressBar>
    );
};
